import { getStorage } from '../../../utils/enhancedStorage'
import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'

export const setInLocalStorageWithExpiry = (
  key: string,
  value: string,
  expiryInMinutes?: number,
  isGlobal = true, // Default to global for backward compatibility
) => {
  if (!isBrowser()) return
  try {
    const now = new Date()
    // @i18n-ignore
    const MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS = new Date('Fri, 18 May 2035 12:00:00 UTC').getTime()
    const data: LocalStorageData = {
      key: key,
      value: value,
      expiryInMs: expiryInMinutes ? now.getTime() + expiryInMinutes * 60 * 1000 : MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS,
    }
    console.log('Setting key value in local storage with expiry : ', data)

    // Use enhanced storage for locale support
    const storage = getStorage()
    storage.setItem(key, JSON.stringify(data), { isGlobal })
  } catch (error) {
    captureException('setInLocalStorageWithExpiry error', {
      module: MODULES.LOCAL_STORAGE,
      feature: FEATURES.SET_IN_LOCAL_STORAGE_WITH_EXPIRY,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'Set in local storage with expiry function',
        localStorageKey: key,
        localStorageValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

/**
 * Enhanced version with explicit locale support
 * @param key - The key to store
 * @param value - The value to store
 * @param expiryInMinutes - Expiry time in minutes (optional)
 * @param isGlobal - Whether data should be shared across languages (default: false)
 */
export const setInLocalStorageWithExpiryLocalized = (
  key: string,
  value: string,
  expiryInMinutes?: number,
  isGlobal = false, // Default to localized for new usage
) => {
  setInLocalStorageWithExpiry(key, value, expiryInMinutes, isGlobal)
}
